import { render } from "./ArgonLoader.vue?vue&type=template&id=ed117f1e&scoped=true"
const script = {}

import "./ArgonLoader.vue?vue&type=style&index=0&id=ed117f1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed117f1e"]])

export default __exports__